export default __webpack_public_path__ + "static/media/about-1-comp.984a682d.jpg";